export enum SummaryTabs {
  CurrentDprSummary = 'current-dpr-summary',
  Next24hPlanning = 'next-24h-planning',
  ExternalPartyComment = 'external-party-comment',
}
